exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_swiper__3oOex {\n  --f7-grid-gap: var(--product-swiper-grid-gap);\n}\n\n.styles_empty__D8Cwo {\n  text-align: center;\n  font-size: 1rem;\n  padding: .5rem 0;\n  color: var(--f7-theme-color);\n  font-weight: bold;\n  /* background: #f9f9f9; */\n}\n\n.styles_swiperSlide__yZoAA {\n  width: var(--product-swiper-item-width) !important;\n  margin-left: var(--f7-grid-gap);\n}", ""]);

// Exports
exports.locals = {
	"swiper": "styles_swiper__3oOex",
	"empty": "styles_empty__D8Cwo",
	"swiperSlide": "styles_swiperSlide__yZoAA"
};